import { ComponentMultiStyleConfig } from "@chakra-ui/react";
import { alertAnatomy as parts } from "@chakra-ui/anatomy";

const Alert: ComponentMultiStyleConfig = {
  parts: parts.keys,
  baseStyle: {
    container: { rounded: "lg", shadow: "md" },
  },
  defaultProps: { variant: "left-accent" },
};

export default Alert;
